import realtimeSchema from '../apis/capworks-realtime.asyncapi.json';

const channelDescriptions = {
  sessionEvents: '会话快照、事件补发、心跳、在线状态与协作草稿',
  conversationEvents: '成果集快照、工作对象事件、在线状态与协作草稿',
  transcriptionStream: '实时音频、转写增量、提交结果和说话人识别',
};

export function RealtimeApiPage() {
  return (
    <main style={{ margin: '0 auto', maxWidth: 1100, padding: '32px 20px 64px' }}>
      <div style={{ marginBottom: 24 }}>
        <p style={{ color: 'var(--muted-foreground)', fontSize: 14, fontWeight: 650, letterSpacing: '0.08em', margin: 0, textTransform: 'uppercase' }}>
          AsyncAPI 3.0
        </p>
        <h1 style={{ fontSize: 36, letterSpacing: '-0.03em', lineHeight: 1.15, margin: '8px 0 10px' }}>
          CapWorks 实时 API
        </h1>
        <p style={{ color: 'var(--muted-foreground)', fontSize: 16, lineHeight: 1.7, margin: 0, maxWidth: 820 }}>
          会话事件、成果协作和实时转写共用正式登录会话。客户端应实现断线续传、幂等更新以及 1008 鉴权关闭处理。
        </p>
      </div>
      <div style={{ display: 'grid', gap: 16 }}>
        {Object.entries(realtimeSchema.channels).map(([channelId, channel]) => (
          <section key={channelId} style={{ border: '1px solid var(--border)', borderRadius: 12, overflow: 'hidden' }}>
            <div style={{ background: 'var(--muted)', padding: '18px 20px' }}>
              <div style={{ alignItems: 'center', display: 'flex', flexWrap: 'wrap', gap: 10 }}>
                <span style={{ background: 'hsl(var(--primary))', borderRadius: 6, color: 'hsl(var(--primary-foreground))', fontSize: 12, fontWeight: 700, padding: '4px 8px' }}>
                  WebSocket
                </span>
                <code style={{ fontSize: 15 }}>{channel.address}</code>
              </div>
              <p style={{ color: 'var(--muted-foreground)', margin: '10px 0 0' }}>
                {channelDescriptions[channelId as keyof typeof channelDescriptions]}
              </p>
            </div>
            <div style={{ display: 'grid', gap: 12, gridTemplateColumns: 'repeat(auto-fit, minmax(280px, 1fr))', padding: 20 }}>
              {Object.entries(channel.messages).map(([direction, message]) => {
                const messageId = message.$ref.split('/').at(-1) as keyof typeof realtimeSchema.components.messages;
                const definition = realtimeSchema.components.messages[messageId];
                const schemaId = definition.payload.$ref.split('/').at(-1) as keyof typeof realtimeSchema.components.schemas;
                return (
                  <div key={direction} style={{ border: '1px solid var(--border)', borderRadius: 10, padding: 16 }}>
                    <div style={{ color: 'var(--muted-foreground)', fontSize: 12, fontWeight: 700, letterSpacing: '0.06em', textTransform: 'uppercase' }}>
                      {direction === 'clientMessage' ? 'Client → Server' : 'Server → Client'}
                    </div>
                    <h2 style={{ fontSize: 17, margin: '8px 0 4px' }}>{definition.title}</h2>
                    <code style={{ color: 'var(--muted-foreground)', fontSize: 13 }}>{definition.name}</code>
                    <details style={{ marginTop: 14 }}>
                      <summary style={{ cursor: 'pointer', fontWeight: 650 }}>查看消息 Schema</summary>
                      <pre style={{ background: 'var(--muted)', borderRadius: 8, fontSize: 12, marginTop: 10, maxHeight: 420, overflow: 'auto', padding: 14 }}>
                        {JSON.stringify(realtimeSchema.components.schemas[schemaId], null, 2)}
                      </pre>
                    </details>
                  </div>
                );
              })}
            </div>
          </section>
        ))}
      </div>
      <p style={{ color: 'var(--muted-foreground)', marginTop: 24 }}>
        原始 AsyncAPI 3.0 规范：<a href="/apis/capworks-realtime.asyncapi.json" download>下载 JSON</a>
      </p>
    </main>
  );
}
